<template>
  <div class="container mt-2 mb-0">
    <h4 class="">
      {{ title }}
      <small class="text-danger text-tiny"> *</small>
    </h4>
    <b-form-group>
      <b-form-radio-group

        :options="selects"
        class=""
        name="radio-inline"
      />
    </b-form-group>

  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormTextarea,
  BFormRadio,
  BFormRadioGroup,
  BCardText,
} from 'bootstrap-vue'
// import { required, email } from '@validations'

export default {
  components: {
    // ValidationProvider,
    // ValidationObserver,
    // FormWizard,
    // TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormRadio,
    BFormRadioGroup,
    BCardText,
    // vSelect,
    // BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    // ToastificationContent,
    BForm,
    BButton,
    BCard,
    BFormTextarea,
  },
  props: {
    selects: {
      type: Array,
    },
    title: {
      type: String,
    },
  },
  created() {
    // `this` points to the vm instance
    // console.log(`custom group a is: ${this.a}`)
    // console.log('this.selects', this.selects)
  },
  methods: {
    checkboxChanged() {
      // console.log(this.selects)
    },
  },
}

</script>

<style>

</style>
